import React from 'react';

// Drapeau basque (Ikurriña) - composant SVG
const BasqueFlag = ({ size = 40, className = "" }) => {
  return (
    <svg 
      width={size} 
      height={size * 0.6} 
      viewBox="0 0 100 60" 
      className={className}
      style={{ borderRadius: '4px', boxShadow: '0 2px 8px rgba(0,0,0,0.2)' }}
    >
      {/* Fond vert */}
      <rect width="100" height="60" fill="#006633" />
      
      {/* Croix blanche diagonale */}
      <path 
        d="M0 0 L100 60 M100 0 L0 60" 
        stroke="white" 
        strokeWidth="12" 
        fill="none"
      />
      
      {/* Croix rouge (Saint-André) */}
      <path 
        d="M50 0 L50 60 M0 30 L100 30" 
        stroke="#9B1B30" 
        strokeWidth="8" 
        fill="none"
      />
    </svg>
  );
};

export default BasqueFlag;
